import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type {
  BrandBase,
  BrandById,
  BrandCreatePayload,
  BrandUpdatePayload,
  BrandItem,
  BrandItemListParams,
} from '../model/types';
import type { ApiResponseList } from '@/shared/api/types';

export const getList = async (params?: RequestParams): Promise<ApiResponseList<BrandBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<BrandBase>>(`${API_PREFIX.ADMIN_V1}/brand/index`, {
    params,
  });

  return data;
};

export const getItemList = async (params?: BrandItemListParams): Promise<ApiResponse<BrandItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<BrandItem[]>>(`${API_PREFIX.ADMIN_V1}/brand/item-list`, {
    params: params,
  });

  return data;
};

export const getById = async (id: number): Promise<ApiResponse<BrandById>> => {
  const { data } = await axiosInstance.get<ApiResponse<BrandById>>(`${API_PREFIX.ADMIN_V1}/brand/show`, {
    params: { id },
  });

  return data;
};

export const create = async (payload: BrandCreatePayload): Promise<ApiResponse<BrandById>> => {
  const { data } = await axiosInstance.post<ApiResponse<BrandById>>(`${API_PREFIX.ADMIN_V1}/brand/create`, payload);

  return data;
};

export const update = async (payload: BrandUpdatePayload): Promise<ApiResponse<BrandById>> => {
  const { data } = await axiosInstance.post<ApiResponse<BrandById>>(`${API_PREFIX.ADMIN_V1}/brand/update`, payload);

  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${API_PREFIX.ADMIN_V1}/brand/delete`, { id });

  return data;
};
